import _taggedTemplateLiteral from "/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import React from 'react';
import { Button as Button$1 } from '@mui/material';
import { styled } from '@mui/material/styles';
const Button = styled(Button$1, {
  shouldForwardProp: p => p !== "state" && p !== "variant" && p !== "color" && p !== "size"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    && {\n        width: 100%;\n        height: 100%;\n        font-family: inherit !important;\n        font-size: inherit !important;\n        font-weight: inherit !important;\n        letter-spacing: inherit;\n        text-transform: inherit;\n        line-height: inherit;\n        margin: 0;\n        border-radius: ", ";\n        color: ", ";\n        background-color: ", ";\n        :active,\n        :focus,\n        :visited,\n        :hover {\n            background-color: ", ";\n            color: ", ";\n        }\n        padding: 0.46875rem 1rem;\n        text-align: center;\n        border: ", ";\n    }\n"])), _ref => {
  let {
    theme,
    size
  } = _ref;
  return theme.uxfabric.shape.global.button[size].borderRadius;
}, _ref2 => {
  let {
    theme,
    state,
    color,
    variant
  } = _ref2;
  return theme.uxfabric.components.button[variant][color][state].contrastTextColor;
}, _ref3 => {
  let {
    theme,
    state,
    color,
    variant
  } = _ref3;
  return theme.uxfabric.components.button[variant][color][state].backgroundColor;
}, _ref4 => {
  let {
    theme,
    state,
    color,
    variant
  } = _ref4;
  return theme.uxfabric.components.button[variant][color][state].backgroundColor;
}, _ref5 => {
  let {
    theme,
    color,
    variant,
    state
  } = _ref5;
  return theme.uxfabric.components.button[variant][color][state].contrastTextColor;
}, _ref6 => {
  let {
    state,
    theme,
    color,
    variant
  } = _ref6;
  return theme.uxfabric.components.button[variant][color][state].borderColor !== undefined ? "1px solid ".concat(theme.uxfabric.components.button[variant][color][state].borderColor) : "none";
});
const UxCTA = _ref7 => {
  let {
    disabled,
    url,
    text,
    color,
    state,
    variant,
    size,
    onClick,
    testId,
    dataGaV1,
    dataGaV2,
    dataGaV3,
    endIcon
  } = _ref7;
  return /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    href: url,
    onClick: onClick,
    color: color,
    variant: variant,
    size: size,
    state: state,
    disableRipple: true,
    "data-testid": testId,
    "data-ga-v1": dataGaV1,
    "data-ga-v2": dataGaV2,
    "data-ga-v3": dataGaV3,
    endIcon: endIcon
  }, text);
};
export { UxCTA };